import { z } from "zod";

/**
 * Organization display name field - required with min length
 */
export const organizationNameField = z
  .string()
  .min(1, "Organization name is required")
  .max(255, "Organization name must be 255 characters or less");
